/* eslint-disable */

import React, { useEffect, useMemo, useCallback } from 'react'
import { Box, Button, Container, Divider, Grid, Typography } from '@aura/components'
import { withStyles } from '@aura/components/styles'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import CustomLoader from '../../../../components/custom-loader'
import RegistrationContainer from '../../../../components/new-registration-container'
import FetchUserAppsStatus from '../../../../constants/fetch-user-apps'
import { isFrench } from '../../../../constants/app'
import { loginUrls } from '../../../../appConfig'
import styles from './styles'


const Component = ({
    classes,
    initUserApps,
    data,
    userAppsStatus
}) => {

    const { t: translate, i18n } = useTranslation()

    useEffect(() => {
        initUserApps()
    }, [])

    const currentLanguage = i18n.resolvedLanguage || i18n.language || 'en'

    const generalLogin = data?.generalLogin ? data.generalLogin + `/${currentLanguage}` : null

    const handleResendResetLink = useCallback(() => {
        window.open(generalLogin, '_self')
    }, [ generalLogin ])

    const isLoading = userAppsStatus === FetchUserAppsStatus.PENDING

    const myApps = data && data.myApps ? data.myApps.filter(app => app.url && loginUrls.some(suffix => app.url.endsWith(suffix))) : null

    const mainContent = useMemo(() => {
        return <div className={classes.fieldsContainer}>
            {isLoading ? (
                <CustomLoader
                    label={translate('loading')}
                    style={{ marginBottom: '100px', marginTop: '26%', width: '100%' }}
                />
            ) : <>
                <Container>
                    <Box className={classes.firstPart}>
                        <CheckCircleOutlineIcon className={classes.checkIcon}></CheckCircleOutlineIcon>
                        <Typography className={classes.registrationSuccess}>{translate('forgotPwdFlow.successTitle')}</Typography>

                    </Box>
                    <Divider className={classes.headerDivider} />
                </Container>
                <Box className={classes.secondPart}>
                    <Typography className={`${classes.loginTextSecond}`}> {translate('forgotPwdFlow.successMessage')}</Typography>
                    <Box className={classes.buttonContainer}>
                            <Button
                                className={classes.nextButton}
                                color='primary'
                                disabled={!generalLogin}
                                onClick={handleResendResetLink}>
                                {translate('loginText')}
                            </Button>
                    </Box>
                    {myApps && myApps.length > 0
                        ? <>
                            <Typography className={classes.loginTextSecond} variant="body2">{translate('forgotPwdFlow.successSubMessage')}</Typography>
                            <Box className={classes.signIntoApps} mt={2} mb={2} display="flex" flexWrap="wrap" gap="10px">
                                {Object.values(myApps).map(rec => (
                                    <Grid key={rec.appNameEn} item>
                                        <Button
                                            className={classes.appsButton}
                                            disabled={!myApps || !rec.url}
                                            onClick={() => { rec.url && window.open(rec.url, '_blank'); setCookieHandler() }}

                                        >
                                            {isFrench(i18n.language) ? rec.appNameFr : rec.appNameEn}
                                        </Button>
                                    </Grid>
                                ))}
                            </Box>
                        </>
                        : <></>}
                </Box>
            </>
            }
        </div>

    }, [classes, translate, isLoading, myApps, generalLogin, currentLanguage])
    return (<RegistrationContainer {...{ mainContent }}>

    </RegistrationContainer>)
}

Component.displayName = 'ForgotPwdComplete'

Component.defaultProps = {
    data: {
        myApps: []
    }
}

Component.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.object,
        buttonContainer: PropTypes.object,
        fieldsContainer: PropTypes.object,
        signIntoApps: PropTypes.object
    }),
    data: PropTypes.object.isRequired,
    initUserApps: PropTypes.func.isRequired,
    userAppsStatus: PropTypes.string
}

export default withStyles(Component, styles)
